export default __webpack_public_path__ + "static/media/dashboard.609bd7bb.svg";